let ctx = null;

function ac() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function soundOn() {
  return localStorage.getItem("lostdc_sound") !== "off";
}

export function setSoundOn(v) {
  localStorage.setItem("lostdc_sound", v ? "on" : "off");
}

function tone(freq, dur = 0.12, type = "triangle", vol = 0.06, delay = 0) {
  if (!soundOn()) return;
  try {
    const c = ac();
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.value = freq;
    g.gain.setValueAtTime(0, c.currentTime + delay);
    g.gain.linearRampToValueAtTime(vol, c.currentTime + delay + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + delay + dur);
    o.connect(g);
    g.connect(c.destination);
    o.start(c.currentTime + delay);
    o.stop(c.currentTime + delay + dur + 0.05);
  } catch { /* audio unsupported */ }
}

export const playClick = () => tone(700, 0.05, "triangle", 0.04);
export const playSelect = () => tone(560, 0.1, "triangle", 0.07);
export const playNext = () => { tone(440, 0.08); tone(660, 0.1, "triangle", 0.06, 0.07); };
export const playTick = () => tone(880, 0.05, "square", 0.028);
export const playWarn = () => { tone(220, 0.15, "sawtooth", 0.05); tone(180, 0.22, "sawtooth", 0.05, 0.12); };
export const playUnlock = () => [523, 659, 784].forEach((f, i) => tone(f, 0.15, "triangle", 0.07, i * 0.09));
export const playComplete = () => [523, 659, 784, 1047].forEach((f, i) => tone(f, 0.24, "triangle", 0.08, i * 0.12));
